(() => {
    const $footerNewsletterRegistrationForms = document.body.querySelectorAll('.footer-newsletter-registration');

    Array.prototype.forEach.call($footerNewsletterRegistrationForms, $footerNewsletterRegistrationForm => {
        $footerNewsletterRegistrationForm.addEventListener('submit', (e) => {
            e.preventDefault();

            const $email = $footerNewsletterRegistrationForm.querySelector('[type="email"]');

            if ($email.value.trim().length === 0) {
                $email.focus();
                return;
            }

            const formData = new FormData($footerNewsletterRegistrationForm);
            formData.append('option', 'subscribe');

            $footerNewsletterRegistrationForm
                .querySelector('button[type="submit"]')
                .setAttribute('disabled', 'disabled');

            const $wrap = document.createElement('tmp');
            const $responseMessage = document.createElement('p');
            const $icon = document.createElement('span');
            $icon.classList.add('icon');
            $responseMessage.classList.add('footer-newsletter--response');

            $wrap.appendChild($icon);
            $wrap.appendChild($responseMessage);

            fetch($footerNewsletterRegistrationForm.getAttribute('action'), {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: formData,
            })
                .then(response => {
                    if (response.status === 200) {
                        $responseMessage.classList.add('footer-newsletter--response-success');
                        $icon.classList.add('footer-newsletter--icon-success');
                        $icon.innerText = 'F';
                    } else {
                        $responseMessage.classList.add('footer-newsletter--response-error');
                        $icon.classList.add('footer-newsletter--icon-error');
                        $icon.innerText = 'G';
                    }

                    $footerNewsletterRegistrationForm.classList.add('form-submitted');
                    $responseMessage.innerText = response.status === 200
                        ? $footerNewsletterRegistrationForm.dataset.successMessage
                        : $footerNewsletterRegistrationForm.dataset.errorMessage;

                    $footerNewsletterRegistrationForm.innerHTML = $wrap.innerHTML;
                });
        });
    });
})()
